import { signal } from '@preact/signals';

interface ConfirmRequest {
  title: string;
  message: string;
  danger?: boolean;
  resolve: (ok: boolean) => void;
}

export const confirmRequest = signal<ConfirmRequest | null>(null);

export function askConfirm(title: string, message: string, danger = false): Promise<boolean> {
  return new Promise((resolve) => {
    confirmRequest.value = { title, message, danger, resolve };
  });
}
